/**
 * The Nenda symbol as two STROKES, so it can draw itself.
 *
 * Geometry from the brand file (Nenda-symbol-white-RGB.eps, Illustrator,
 * 118.72 pt artboard): the symbol is two 7-unit strokes with round caps and
 * joins, which Illustrator stored as outlines. These are their centre lines,
 * derived from the outline points and verified by overlaying them on the
 * brand PNG (2026-10-26). Illustrator's EPS coordinates already run top-down
 * here, so they are used as-is.
 *
 * `pathLength="1"` normalises both strokes, so the draw-on animation is a
 * dash offset from 1 to 0 whatever their real lengths.
 */
export const NENDA_STROKES = [
  // Left half: bottom stub → bottom-left corner → up → long diagonal.
  "M49.21 74.72 L31.25 87.53 L31.25 31.19 L69.51 58.47",
  // Right half: long diagonal → bottom-right corner → up → top stub.
  "M49.21 60.25 L87.47 87.52 L87.47 31.19 L69.51 44.00",
] as const;

/** The symbol's own bounds (stroke included), as an SVG viewBox. */
export const NENDA_VIEWBOX = "27.25 27.2 64.22 64.33";

export function NendaSymbol({
  className,
  draw = false,
}: {
  className?: string;
  /** Animate the strokes drawing on (CSS, see `.nenda-symbol--draw`). */
  draw?: boolean;
}) {
  return (
    <svg
      className={`nenda-symbol${draw ? " nenda-symbol--draw" : ""}${className ? ` ${className}` : ""}`}
      viewBox={NENDA_VIEWBOX}
      aria-hidden="true"
      focusable="false"
    >
      <g
        fill="none"
        stroke="currentColor"
        strokeWidth="7"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        {NENDA_STROKES.map((d) => (
          <path key={d} d={d} pathLength={1} />
        ))}
      </g>
    </svg>
  );
}
